/**
 * De sleutels die een scherm met een opmerking meestuurt, in gewone woorden
 * (ontwerp 28-10-2026, schermen 34 en 35: "verslagjaar 2026 · filter Twello").
 * De API bewaart de sleutel zoals het scherm hem stuurde; alleen de weergave
 * vertaalt. Een sleutel die hier niet staat, blijft zichtbaar zoals hij is, zodat
 * er nooit context wegvalt.
 */
const LABELS: Record<string, string> = {
  reporting_year: "verslagjaar",
  baseline_reporting_year: "basisjaar",
  filters: "filter",
  theme: "thema",
  run_id: "run",
  asset_id: "object",
  ticket: "ticket",
  open: "nog oppakken",
  in_progress: "mee bezig",
  handled: "afgerond",
};

/** Het label bij een contextsleutel, of de sleutel zelf als hij onbekend is. */
export function contextLabel(key: string): string {
  return LABELS[key] ?? key;
}

/** Eén contextregel: "verslagjaar 2026"; onbekend blijft "sleutel: waarde". */
export function contextPart(key: string, value: unknown): string {
  const label = LABELS[key];
  return label ? `${label} ${String(value)}` : `${key}: ${String(value)}`;
}
